import { RouteRecordRaw } from 'vue-router'

/* ClientApp */
import ClientAppForm from '@/apps/admin/components/client-app/ClientAppForm.vue'
import ClientAppList from '@/apps/admin/components/client-app/ClientAppList.vue'
import GroupForm from '@/apps/admin/components/group/GroupForm.vue'
import GroupList from '@/apps/admin/components/group/GroupList.vue'
import MainMenu from '@/apps/admin/components/MainMenu.vue'
import OrganisationForm from '@/apps/admin/components/organisation/OrganisationForm.vue'
import OrganisationList from '@/apps/admin/components/organisation/OrganisationList.vue'
/* Permission */
import ObjectAuthorizationForm from '@/apps/admin/components/permission/ObjectAuthorizationForm.vue'
import ObjectAuthorizationList from '@/apps/admin/components/permission/ObjectAuthorizationList.vue'
import RoleForm from '@/apps/admin/components/permission/RoleForm.vue'
import RoleList from '@/apps/admin/components/permission/RoleList.vue'
import ProfileList from '@/apps/admin/components/user/ProfileList.vue'
import UserForm from '@/apps/admin/components/user/UserForm.vue'
import RouterPassThrough from '@/components/common/RouterPassThrough.vue'

import { clientAppRegistryGet } from '../clientAppRegistry'
import { adminRouteName, VIEW_ID } from './app'

const route: RouteRecordRaw = {
  path: clientAppRegistryGet(VIEW_ID, 'path'),
  name: VIEW_ID,
  redirect: { name: adminRouteName('organisation-root') },
  components: {
    default: RouterPassThrough,
    'main-menu': MainMenu,
  },
  children: [
    {
      path: 'organisation',
      name: adminRouteName('organisation-root'),
      redirect: { name: adminRouteName('organisation-list') },
      component: RouterPassThrough,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'list',
          name: adminRouteName('organisation-list'),
          props: true,
          component: OrganisationList,
          meta: {
            requiresList: {
              organisation: true,
            },
          },
        },
        {
          path: 'create',
          name: adminRouteName('organisation-create'),
          props: { id: '0' },
          component: OrganisationForm,
        },
        {
          path: ':id',
          name: adminRouteName('organisation-detail'),
          props: true,
          component: OrganisationForm,
          meta: {
            detailOf: 'organisation',
          },
        },
      ],
    },
    {
      path: 'user',
      name: adminRouteName('profile-root'),
      redirect: { name: adminRouteName('profile-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: adminRouteName('profile-list'),
          props: true,
          component: ProfileList,
          meta: {},
        },
        {
          path: 'create',
          name: adminRouteName('profile-create'),
          component: UserForm,
          props: { id: '0' },
        },
        {
          path: ':id',
          name: adminRouteName('profile-detail'),
          props: true,
          component: UserForm,
          meta: {},
        },
      ],
    },
    {
      path: 'role',
      name: adminRouteName('role-root'),
      redirect: { name: adminRouteName('role-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: adminRouteName('role-list'),
          props: true,
          component: RoleList,
          meta: {
            requiresList: {
              role: true,
            },
          },
        },
        {
          path: 'create',
          name: adminRouteName('role-create'),
          component: RoleForm,
          props: { id: '0' },
        },
        {
          path: ':id',
          name: adminRouteName('role-detail'),
          props: true,
          component: RoleForm,
        },
      ],
    },
    {
      path: 'group',
      name: adminRouteName('group-root'),
      redirect: { name: adminRouteName('group-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: adminRouteName('group-list'),
          props: true,
          component: GroupList,
          meta: {
            requiresList: {
              group: true,
            },
          },
        },
        {
          path: 'create',
          name: adminRouteName('group-create'),
          component: GroupForm,
          props: { id: '0' },
        },
        {
          path: ':id',
          name: adminRouteName('group-detail'),
          props: true,
          component: GroupForm,
        },
      ],
    },
    {
      path: 'object-authorization',
      name: adminRouteName('object-authorization-root'),
      redirect: { name: adminRouteName('object-authorization-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: adminRouteName('object-authorization-list'),
          props: true,
          component: ObjectAuthorizationList,
          meta: {
            requiresList: {
              'object-authorization': true,
            },
            hasQuery: {
              role: true,
              // group: true,
            },
          },
        },
        {
          path: 'create',
          name: adminRouteName('object-authorization-create'),
          props: { id: '0' },
          component: ObjectAuthorizationForm,
          meta: {
            requiresList: {
              role: true,
            },
          },
        },
        {
          path: ':id',
          name: adminRouteName('object-authorization-detail'),
          props: true,
          component: ObjectAuthorizationForm,
        },
      ],
    },
    {
      path: 'client-app',
      name: adminRouteName('client-app-root'),
      redirect: { name: adminRouteName('client-app-list') },
      component: RouterPassThrough,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: adminRouteName('client-app-list'),
          props: true,
          component: ClientAppList,
          meta: {},
        },
        {
          path: 'create',
          name: adminRouteName('client-app-create'),
          component: ClientAppForm,
          props: { id: '0' },
        },
        {
          path: ':id',
          name: adminRouteName('client-app-detail'),
          props: true,
          component: ClientAppForm,
        },
      ],
    },
  ],
}

export default route
